import { render } from "./QuantityOfTransfersPerDayChartContainer.vue?vue&type=template&id=4a7944d2"
import script from "./QuantityOfTransfersPerDayChartContainer.vue?vue&type=script&lang=js"
export * from "./QuantityOfTransfersPerDayChartContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__